import 'select2';

import * as _ from 'lodash';

import {
    BaseModifyDashboardWidgetView, BaseModifyDashboardWidgetViewOptions
} from '../../dashboard/modify_widgets/_BaseModifyWidgetView';

export class ModifyDateTimeWidgetView extends BaseModifyDashboardWidgetView {

    private template = _.template(require('templates/modals/reports/modify_widgets/datetimewidget/datetimewidget.html'));

    constructor(options: BaseModifyDashboardWidgetViewOptions) {
        super(<any> _.extend({
            tagName: "div",
            className: 'widget-type-channels',
            events: {}
        }, options));

        if (!this.options.widget) {
            this.options.widget = new this.options.dashboardWidgetCollection.model({
                dashboard_id: this.options.dashboardId,
                params: []
            });
        }
    }

    render() {
        this.$el.html(this.template({
            exampleImg: require('../../../../../img/widgettypes/datetime/datetimewidgetexample.png')
        }));
        return this;
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/modals/reports/modify_widgets/ModifyDateTimeWidgetView.ts